<script setup lang="ts">
const properties = defineProps<{
  text: string
  title: string
}>()

const open = defineModel({
  default: false
})
const emit = defineEmits(['clicked'])

const onClick = () => {
  open.value = !open.value
  emit('clicked', open.value)
}

</script>

<template>
  <div class="hover-border relative">
    <div
      :class="[open ? 'font-bold' : '']"
      @click="onClick"
      class="flex cursor-pointer gap-2 px-5 py-4 text-xl md:px-0"
    >
      <p>{{ open ? '-' : '+' }}</p>
      <p>{{ title }}</p>
    </div>
    <div
      :class="{
        'grid-rows-[0fr]': !open,
        'grid-rows-[1fr]': open,
      }"
      class="grid overflow-hidden transition-[grid-template-rows_0.6s_ease-in-out]"
    >
      <div class="min-h-0">
        <div
          class="prose !max-w-full p-10 lg:px-12 lg:py-10"
          v-html="text"
        ></div>
      </div>
    </div>
  </div>
</template>

<style>
.hover-border::after {
  content: '';
  position: absolute;
  top: 100%;
  transform-origin: right;
  display: block;
  width: 100%;
  height: 4px;
  @apply bg-sunglow;
  transform: scaleX(0);
  transition: transform 0.6s;
  border-radius: 4px;
}

.hover-border:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}
</style>
